export enum Steps {
  CommunityCard = 'communityCard',
  LoginCard = 'loginCard',
}
